import { useCallback } from 'react'
import ModalCreateProductConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Products/ModalCreateProduct'
import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { ITLayoutTableModalOpen } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableLayoutData, InputTableURLsTable, OrderHeaderURLs } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { BuildedOrder } from '../../../../../baseComponents/TwinTable/types'
import { OnSubmit } from '../../../../../forms/TwinForm/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { addAntiUnsaveElement } from '../../../../../utils/reducers/reduxDispatch'
import { OnChangeOrderAddProduct } from '../../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput/types'
import ModalComplexProductVariantsOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalComplexProductVariantsOrder'
import ModalDeleteLineOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalDeleteLineOrder'
import ModalEditableTextProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditableTextProductOrder'
import ModalComplementProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditAddonProductOrder'
import ModalEditProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditProductOrder'
import ModalPriceProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalPriceProductOrder'
import ModalSyncProductPriceOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalSyncProductPriceOrder'
import ModalWarehouseProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalWarehouseProductOrder'
import ModalAddRechargesOrder from '../../OrderLayout/OrderTotal/FooterOrderTotal/Components/ModalFinancialRowsOrder/ModalAddRechargeOrder'
import ModalConfigShippingSellOrder from '../../OrderSellLayout/ModalsOrderSellLayout/ModalConfigShippingSellOrder'
import ModalPrintSingleTagSellConnect from '../../OrderSellLayout/ModalsOrderSellLayout/ModalPrintSingleTagSell'
import ModalUniqueNumberProductOrderSell from '../../OrderSellLayout/ModalsOrderSellLayout/ModalUniqueNumberProductOrderSell'
import ModalWorkSheetStatusOrderProduct from '../../OrderSellLayout/ModalsOrderSellLayout/ModalWorkSheetStatusOrderProduct'
import { SetTPVCompleteDataTy } from '../types'
import ModalAddDiscountSellTicket from './ModalAddDiscountSellTicket'

interface ModalsOrderSellTicketLayoutProps extends ModalsOrderSellTicketLayoutLogicProps {
    openModal: ITLayoutTableModalOpen
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    onChangeAdd: OnChangeOrderAddProduct
    onChangeUpdate: () => void
    deleteLine: (id: number) => void
    inputTableURLs: InputTableURLsTable
    userPermissions: UserPermissions
    headerData: TwinDictionary
    onChangeFetch: (rowIndex: number, keyValue: string, value: string) => Promise<void>
    completeData: InputTableLayoutData
    isReadOnly?: boolean
    orderHeaderURLs: OrderHeaderURLs
    modelId: string
    myOrderId?: number
    setCompleteData: SetTPVCompleteDataTy
}

const ModalsOrderSellTicketLayout: React.FC<ModalsOrderSellTicketLayoutProps> = ({ openModal, onChangeAdd, onChangeUpdate, onChangeFetch, deleteLine, setOpenModal, getCompleteData, ...rest }) => {
    const { myOnSubmitModalComplex } = useModalsOrderSellTicketLayoutLogic({getCompleteData, ...rest})
    const typeDict: any = {
        editProduct: { component: ModalEditProductOrder, onSubmit: onChangeUpdate },
        priceProduct: { component: ModalPriceProductOrder, onSubmit: onChangeUpdate },
        deleteLine: { component: ModalDeleteLineOrder, onSubmit: () => deleteLine(openModal?.allRowData.id) },
        complexProduct: {
            component: ModalComplexProductVariantsOrder, onSubmit: myOnSubmitModalComplex
        },
        editableText: { component: ModalEditableTextProductOrder, onSubmit: (value: any) => onChangeFetch(openModal?.allRowData.absoluteIndex || openModal?.allRowData.rowIndex, openModal?.allRowData.dataKey, value) },
        editAddonProduct: { component: ModalComplementProductOrder, onSubmit: onChangeUpdate },
        uniqueNumber: { component: ModalUniqueNumberProductOrderSell, onSubmit: onChangeUpdate },
        warehouses: { component: ModalWarehouseProductOrder },
        syncPrice: { component: ModalSyncProductPriceOrder, onSubmit: getCompleteData },
        workSheetStatus: { component: ModalWorkSheetStatusOrderProduct },
        printTags: { component: ModalPrintSingleTagSellConnect },
        configShipping: { component: ModalConfigShippingSellOrder },
        addDiscount: { component: ModalAddDiscountSellTicket },
        addRecharge: { component: ModalAddRechargesOrder },
        createProduct: { component: ModalCreateProductConnect, onSubmit: openModal?.allRowData?.onSubmit }
    }
    if (openModal?.type && openModal.type in typeDict) {
        const element = typeDict[openModal.type]
        const Component = element.component
        const onSubmit = element.onSubmit
        return <Component allRowData={openModal.allRowData} {...rest} orderURLs={rest.inputTableURLs} onSubmit={onSubmit} setOpened={() => setOpenModal(null)} tableData={rest.completeData.tableData} getCompleteData={getCompleteData} navigateToProduct={false} />
    }
    return null
}

interface ModalsOrderSellTicketLayoutLogicProps {
    getCompleteData: (order?: BuildedOrder, updateLastProduct?: boolean) => Promise<void>
}

const useModalsOrderSellTicketLayoutLogic = ({ getCompleteData }: ModalsOrderSellTicketLayoutLogicProps) => {
    const myOnSubmitModalComplex: OnSubmit = useCallback(async (res) => {
        const result = await res.json()
        await addAntiUnsaveElement(['sellTicket', '{}'])
        await getCompleteData(result?.[0]?.OrderId, true)
    }, [getCompleteData])
    return { myOnSubmitModalComplex }
}

export default ModalsOrderSellTicketLayout